import { useMediaQuery } from '@mui/material';

/**
 * Shared mobile breakpoint for the agent UI.
 *
 * Kept in one place so the JS checks stay in sync with the CSS media queries.
 * 768px matches the app shell (App.css) and the embedded Activepieces UI
 * (packages/react-ui/src/hooks/use-mobile.tsx), so all three layers agree on
 * where "mobile" starts.
 */
export const MOBILE_BREAKPOINT = 768;

const useIsMobile = () =>
  useMediaQuery(`(max-width:${MOBILE_BREAKPOINT}px)`, { noSsr: true });

export default useIsMobile;
